<header>
    <h2>{{"Histórico de Importações"}}</h2>
    <button mat-dialog-close id="close-button">
        <mat-icon>close</mat-icon>
    </button>
</header>
<section>
    <div class="item" *ngIf="data[0] as i"
        [ngClass]="i.status == Enum.Aborted || i.status == Enum.Error ? 'error' : (
            i.status == Enum.Completed ? 'completed' : 'ongoing'
        )"
    >
        <div>
            <mat-icon class="error-icon" *ngIf="i.status == Enum.Aborted || i.status == Enum.Error">close</mat-icon>
            <mat-icon class="completed-icon" *ngIf="i.status == Enum.Completed">done</mat-icon>
            <mat-icon class="ongoing-icon" *ngIf="i.status != Enum.Completed && i.status != Enum.Aborted && i.status != Enum.Error">schedule</mat-icon>
            <span><strong>{{i.fileName}}</strong>{{i.historyMessage}}</span>
        </div>
        <button *ngIf="i.status == Enum.ValidatedProducts" class="blue-flat-button confirm-button" (click)="reviewImportation(i.id)">Revisar</button>
    </div>

    <div class="item" *ngIf="data[1] as i"
        [ngClass]="i.status == Enum.Aborted || i.status == Enum.Error ? 'error' : (
            i.status == Enum.Completed ? 'completed' : 'ongoing'
        )"
    >
        <div>
            <mat-icon class="error-icon" *ngIf="i.status == Enum.Aborted || i.status == Enum.Error">close</mat-icon>
            <mat-icon class="completed-icon" *ngIf="i.status == Enum.Completed">done</mat-icon>
            <mat-icon class="ongoing-icon" *ngIf="i.status != Enum.Completed && i.status != Enum.Aborted && i.status != Enum.Error">schedule</mat-icon>
            <span><strong>{{i.fileName}}</strong>{{i.historyMessage}}</span>
        </div>
        <button *ngIf="i.status == Enum.ValidatedProducts" class="blue-flat-button confirm-button" (click)="reviewImportation(i.id)">Revisar</button>
    </div>

    <div class="item" *ngIf="data[2] as i"
        [ngClass]="i.status == Enum.Aborted || i.status == Enum.Error ? 'error' : (
            i.status == Enum.Completed ? 'completed' : 'ongoing'
        )"
    >
        <div>
            <mat-icon class="error-icon" *ngIf="i.status == Enum.Aborted || i.status == Enum.Error">close</mat-icon>
            <mat-icon class="completed-icon" *ngIf="i.status == Enum.Completed">done</mat-icon>
            <mat-icon class="ongoing-icon" *ngIf="i.status != Enum.Completed && i.status != Enum.Aborted && i.status != Enum.Error">schedule</mat-icon>
            <span><strong>{{i.fileName}}</strong>{{i.historyMessage}}</span>
        </div>
        <button *ngIf="i.status == Enum.ValidatedProducts" class="blue-flat-button confirm-button" (click)="reviewImportation(i.id)">Revisar</button>
    </div>

    <div class="item" *ngIf="data[3] as i"
        [ngClass]="i.status == Enum.Aborted || i.status == Enum.Error ? 'error' : (
            i.status == Enum.Completed ? 'completed' : 'ongoing'
        )"
    >
        <div>
            <mat-icon class="error-icon" *ngIf="i.status == Enum.Aborted || i.status == Enum.Error">close</mat-icon>
            <mat-icon class="completed-icon" *ngIf="i.status == Enum.Completed">done</mat-icon>
            <mat-icon class="ongoing-icon" *ngIf="i.status != Enum.Completed && i.status != Enum.Aborted && i.status != Enum.Error">schedule</mat-icon>
            <span><strong>{{i.fileName}}</strong>{{i.historyMessage}}</span>
        </div>
        <button *ngIf="i.status == Enum.ValidatedProducts" class="blue-flat-button confirm-button" (click)="reviewImportation(i.id)">Revisar</button>
    </div>

    <div class="item" *ngIf="data[4] as i"
        [ngClass]="i.status == Enum.Aborted || i.status == Enum.Error ? 'error' : (
            i.status == Enum.Completed ? 'completed' : 'ongoing'
        )"
    >
        <div>
            <mat-icon class="error-icon" *ngIf="i.status == Enum.Aborted || i.status == Enum.Error">close</mat-icon>
            <mat-icon class="completed-icon" *ngIf="i.status == Enum.Completed">done</mat-icon>
            <mat-icon class="ongoing-icon" *ngIf="i.status != Enum.Completed && i.status != Enum.Aborted && i.status != Enum.Error">schedule</mat-icon>
            <span><strong>{{i.fileName}}</strong>{{i.historyMessage}}</span>
        </div>
        <button *ngIf="i.status == Enum.ValidatedProducts" class="blue-flat-button confirm-button" (click)="reviewImportation(i.id)">Revisar</button>
    </div>
</section>
